/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AzureCredentialsSupersetSchema
 */
export interface AzureCredentialsSupersetSchema {
    /**
     * 
     * @type {string}
     * @memberof AzureCredentialsSupersetSchema
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCredentialsSupersetSchema
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCredentialsSupersetSchema
     */
    clientSecret?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCredentialsSupersetSchema
     */
    tokenScope?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCredentialsSupersetSchema
     */
    tokenValue?: string;
    /**
     * 
     * @type {number}
     * @memberof AzureCredentialsSupersetSchema
     */
    tokenExpiration?: number;
}

/**
 * Check if a given object implements the AzureCredentialsSupersetSchema interface.
 */
export function instanceOfAzureCredentialsSupersetSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AzureCredentialsSupersetSchemaFromJSON(json: any): AzureCredentialsSupersetSchema {
    return AzureCredentialsSupersetSchemaFromJSONTyped(json, false);
}

export function AzureCredentialsSupersetSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AzureCredentialsSupersetSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'clientSecret': !exists(json, 'client_secret') ? undefined : json['client_secret'],
        'tokenScope': !exists(json, 'token_scope') ? undefined : json['token_scope'],
        'tokenValue': !exists(json, 'token_value') ? undefined : json['token_value'],
        'tokenExpiration': !exists(json, 'token_expiration') ? undefined : json['token_expiration'],
    };
}

export function AzureCredentialsSupersetSchemaToJSON(value?: AzureCredentialsSupersetSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant_id': value.tenantId,
        'client_id': value.clientId,
        'client_secret': value.clientSecret,
        'token_scope': value.tokenScope,
        'token_value': value.tokenValue,
        'token_expiration': value.tokenExpiration,
    };
}

